module.exports = __webpack_public_path__ + "static/media/Logo-Life-1.51d74913.png";